import React, { useState } from "react";
import "./Help.css";

import Form_component from "./form_component/Form_component";

function Help() {
 

  return (
    <>
      <Form_component/>
    </>
  );
}

export default Help;
